import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from '@material-ui/core/styles';
import { BrowserRouter as Router } from 'react-router-dom';

import Header from 'common/components/header/Header';
import Footer from 'common/components/footer/Footer';
import theme from 'common/theme/theme';
import CustomMuiLink from 'common/components/custom-mui-link/CustomMuiLink';
import DialogProvider from 'common/components/dialog-provider/DialogProvider';

ReactDOM.render(
  <Router>
    <ThemeProvider theme={theme}>
      <DialogProvider>
        <React.StrictMode>
          <Header
            RouteLink={(props) => (
              <CustomMuiLink href={props.to} {...props} />
            )}
          />
        </React.StrictMode>
      </DialogProvider>
    </ThemeProvider>
  </Router>,
  document.getElementById('header')
);

ReactDOM.render(
  <Router>
    <ThemeProvider theme={theme}>
      <React.StrictMode>
        <Footer
          RouteLink={(props) => (
            <CustomMuiLink href={props.to} {...props} />
          )}
        />
      </React.StrictMode>
    </ThemeProvider>
  </Router>,
  document.getElementById('footer')
);
